import React from "react";
import BlogFaqs from "../../../components/BlogFaqs";

export default function BlogDetailFaq({ data }) {

  return (
    <>
      <section className="blogfaq-area">
        {!data?.faqs?.[0]?.question ? null :
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="heading center-heading">Frequently Asked Questions</div>
                <BlogFaqs data={data} />
              </div>
            </div>
          </div>
        }

      </section>
    </>
  );
}
